<script lang="ts">
	import type { BlogListItem } from "../templates/BlogProps.js";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import { toDateLongMonthYearFormat } from "../../../core/utils/toDateLongMonthYearFormat.js";
	import logo from "../../../core/assets/logo-blue.svg";
	import arrowRight from "../../../core/assets/icons/arrow-right.svg?raw";
	import DynamicPicture from "./Picture/DynamicPicture.svelte";
	import StaticPicture from "./Picture/StaticPicture.svelte";
	import Link from "./Link.svelte";
	import BlogCategoryBadge from "./BlogCategoryBadge.svelte";
	import ReadingTime from "./ReadingTime.svelte";
	import translations from "./BlogCard.translations.json";
	import { getTranslate } from "../utils/getTranslate.js";
	import { getTenant } from "../getTenant.js";

	export let item: BlogListItem;

	const tenant = getTenant();
	const translate = getTranslate(translations);
	const metaClass = "text-2xs/[1.1875rem] text-ltmeta uppercase tracking-wider";

	$: publishedAt = toDateLongMonthYearFormat(item.publishedAt, tenant.locale);
</script>

<div
	class="border-lttertiary hover:border-ltprimary-300 group flex size-full flex-col border bg-white transition-colors duration-300"
>
	<a href={item.href} class="relative block p-8 pb-0">
		{#if item.primaryImage}
			<DynamicPicture
				class="border-lttertiary block aspect-[16/10] w-full overflow-hidden border object-cover object-center"
				imgClass="size-full object-cover object-center transition-transform duration-500 ease-out group-hover:scale-105"
				alt={item.title}
				image={item.primaryImage}
				width={0}
				height={0}
				bucket="storage"
				sourcesets={{
					"<md": [550, 0],
					">md": [684, 0],
					">lg": [440, 0],
					">xl": [470, 294],
				}}
			/>
		{:else}
			<div class="border-lttertiary bg-lttertiary-50 flex aspect-[16/10] w-full items-center justify-center border">
				<StaticPicture alt="" image={logo} width={250} height={38} class="w-32" imgClass="h-auto w-full" />
			</div>
		{/if}
		<div class="absolute left-8 top-8">
			<BlogCategoryBadge category={item.category} />
		</div>
	</a>

	<div class="flex flex-1 flex-col p-8">
		<div class="flex items-center gap-3.5">
			<span class={metaClass}>{publishedAt}</span>
			<span class="bg-lttertiary size-1 rounded-full"></span>
			<span class={metaClass}><ReadingTime minutes={item.readingMinutes} short /></span>
		</div>
		<div
			class="text-ltprimary font-bahnschrift mt-4 line-clamp-2 text-[1.375rem]/[1.15] uppercase group-hover:underline"
		>
			<a href={item.href}>{nbspify(item.title)}</a>
		</div>
		<div class="text-ltsecondary mt-4 line-clamp-3 text-xs/[1.6]">
			{nbspify(item.perex)}
		</div>
		<div class="mt-auto pt-8">
			<Link
				asButton
				class="font-roboto font-medium uppercase tracking-wider"
				iconClass="h-4 w-2 transition-transform duration-300 group-hover:translate-x-1"
				variant="tertiary"
				icon={arrowRight}
				href={item.href}
				aria-label={translate("readAria", { title: item.title }, true)}>{translate("read")}…</Link
			>
		</div>
	</div>
</div>
